/* ==========================================================================
   PDP Recently Viewed — client-side, localStorage-backed. No app/backend.
   Records the current product handle on every product-page visit, then
   renders up to N other recently-viewed products by fetching their
   /products/{handle}.js data.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'pdp_recently_viewed_handles';
  var MAX_STORED = 12;

  function getStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage unavailable (private mode, quota) — fail silently, no recently-viewed shown */
    }
  }

  function recordCurrent(handle) {
    if (!handle) return;
    var handles = getStored().filter(function (h) { return h !== handle; });
    handles.unshift(handle);
    setStored(handles);
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function render(root, currentHandle, maxItems) {
    var grid = root.querySelector('.js-pdp-recently-viewed-grid');
    var template = document.querySelector('.js-pdp-recently-viewed-item-template');
    if (!grid || !template) return;

    var handles = getStored().filter(function (h) { return h !== currentHandle; }).slice(0, maxItems);
    if (!handles.length) return; // stay hidden — nothing to show yet

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) return;

      valid.forEach(function (p) {
        var node = template.content.cloneNode(true);
        var link = node.querySelector('.pdp-recently-viewed__image-link');
        var img = node.querySelector('img');
        var titleLink = node.querySelector('.pdp-recently-viewed__title a');
        var price = node.querySelector('.pdp-recently-viewed__price');

        var imageUrl = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        link.setAttribute('href', p.url);
        img.setAttribute('src', imageUrl);
        img.setAttribute('alt', p.title);
        titleLink.setAttribute('href', p.url);
        titleLink.textContent = p.title;
        price.textContent = formatMoney(p.price);

        grid.appendChild(node);
      });

      root.hidden = false;
    });
  }

  function init() {
    var root = document.querySelector('.js-pdp-recently-viewed');
    if (!root) return;

    var currentHandle = root.getAttribute('data-current-handle');
    var maxItems = parseInt(root.getAttribute('data-max-items'), 10) || 4;

    render(root, currentHandle, maxItems);
    recordCurrent(currentHandle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
